// extracted by mini-css-extract-plugin
export default {"timer":"timer--joCq","part":"part--is4X","colon":"colon--CVpm","seconds":"seconds--1tSQ"};